import { css } from 'styled-components';

const variables = css`
  :root {
    --dark-navy: #070f1d;
    --navy: #0c1529;
    --light-navy: #172542;
    --lightest-navy: #2a4265;
    --navy-shadow: rgba(3, 10, 23, 0.56);
    --dark-slate: #62708a;
    --slate: #9badc4;
    --light-slate: #c3d1e4;
    --lightest-slate: #eef4ff;
    --white: #ffffff;
    --green: #42d6c4;
    --green-tint: rgba(66, 214, 196, 0.16);
    --pink: #ff9a7a;
    --blue: #7ab5ff;
    --icon-accent: #ffffff;
    --surface: rgba(23, 37, 66, 0.72);
    --surface-strong: rgba(19, 32, 58, 0.9);
    --surface-border: rgba(122, 181, 255, 0.18);
    --header-bg: rgba(8, 16, 33, 0.8);

    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 6px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
